<div class="content-container pb-1 viewinvoice">

    <div class="row mt-3">
      <div class="col-md-2">

        <div class="p-3" *ngIf="businessLogosrc">
          <img [src]="businessLogosrc "  alt="profile picture">
        </div>
      </div>
      <div class="col-1 mt-2 text">
        <span>Invoice</span>
      </div>
      <div class="col-7">
      </div>
      <div class="col-2 mt-2">
        <div class="mt-2">
          <strong>Date</strong> : <span>{{this.viewInvoiceData.invoiceDate}}</span>
        </div>
        <div class="mt-2">
          <strong>Due Date</strong> : <span>{{this.viewInvoiceData.invoiceDueDate}}</span>
        </div>
        <div class="mt-2">
          <strong>Invoice No</strong>: <span>{{this.viewInvoiceData.invoiceNumber}}</span>
        </div>
      </div>
    </div>
    <div class="row mt-3 " style=" background-color: #EDF4FB;">
      <div class=" col-6 mt-2">
        <strong>Bill By</strong>
      </div>
      <div class="ml-2col-6 mt-2 ml-2">
        <strong>Bill To</strong>
      </div>
    </div>
    <div class="divider">
    </div>
    <div class="row" style=" background-color: #EDF4FB;">
      <div class="col-6">
        <strong>{{viewInvoiceData.billedBycompany.companyName}}</strong>
        <address class="mt-3">
          {{viewInvoiceData.billedBycompany.address.addressLine1}}  {{viewInvoiceData.billedBycompany.address.city}} <br>
        {{viewInvoiceData.billedBycompany.address.countryCode}}  {{viewInvoiceData.billedBycompany.address.postCode}}<br>
          Tel: {{viewInvoiceData.billedBycompany.phoneNumber}} <br>
          Email: {{viewInvoiceData.billedBycompany.email}} <br>
        </address>
      </div>
      <div class="col-6">
        <strong>{{viewInvoiceData.billedTocompany.companyName}}</strong>
        <address class="mt-3">
          {{viewInvoiceData.billedTocompany.address.addressLine1}} {{viewInvoiceData.billedTocompany.address.city}}<br>
                {{viewInvoiceData.billedTocompany.address.countryCode}}  {{viewInvoiceData.billedTocompany.address.postCode}}<br>
          Tel: {{viewInvoiceData.billedTocompany.phoneNumber}} <br>
          Email: {{viewInvoiceData.billedTocompany.email}} <br>
        </address>
      </div>
    </div>
    <div class=" row mt-3">
      <p-table [value]="viewInvoiceData.billingItemDTOs" dataKey="id">
        <ng-template pTemplate="header">
          <tr>
            <th>Billing Item </th>
            <th>Chargeable amount</th>
            <th>Discount</th>
            <th>Tax </th>
            <th>Total amount </th>
          </tr>
        </ng-template>
        <!-- <ng-template pTemplate="body" let-order>
          <tr>
            <td>{{order.billingItem}}</td>
            <td>{{order.chargeableAmt}}</td>
            <td>{{order.discountAmt}}</td>
            <td>{{order.taxAmt}}</td>
            <td>{{order.totalAmt}}</td>
          </tr>
        </ng-template> -->
        <ng-template pTemplate="body" let-order let-rowIndex="rowIndex">
          <tr>
            <!-- <td>{{rowIndex + 1}}</td> -->
            <td>{{order.billingItem}}</td>
            <td>
              <!-- <i class="pi pi-dollar" style="font-size: 12px !important"></i> -->
              <i class='icon-style'>
                <img src="../../../../assets/images/invoice/dolar-sign.svg"
                    class="dollar img-style" />
            </i>
             <span class="pos-bottom">{{order.chargeableAmt}}</span> </td>
            <td>
              <!-- <i class="pi pi-dollar" style="font-size: 12px !important"></i> -->
              <i class='icon-style'>
                <img src="../../../../assets/images/invoice/dolar-sign.svg"
                    class="dollar img-style" />
            </i> 
            <span class="pos-bottom">{{order.discountAmt }}</span></td>
            <td>   <i class='icon-style'>
              <img src="../../../../assets/images/invoice/dolar-sign.svg"
                  class="dollar img-style" />
          </i>   <span class="pos-bottom"> {{order.taxAmt}}</span></td>
            <td>  <i class='icon-style'>
              <img src="../../../../assets/images/invoice/dolar-sign.svg"
                  class="dollar img-style" />
          </i><span class="pos-bottom">  {{order.totalAmt}}</span></td>
          </tr>
        </ng-template>


      </p-table>
    </div>

    <div class="row mt-3">
      <div class="col-8"></div>
      <div class="col-4"> 
        <div class="pull-right">
        <strong>Total  : <i class='icon-style '><img src="../../../../assets/images/invoice/dolar-sign.svg"
        class="img-style dollar" />
  </i></strong><strong class="pos-bottom">  {{viewInvoiceData.grandTotal}} </strong>
  <strong class="text-capitalize">({{viewInvoiceData.grandTotalInWords}} dollars only)</strong>
  </div>
      </div>
    </div>
    <div class="row mt-5 mb-5 d-flex justify-content-center">
      <div class="col-6 preview-header">
        <h3>Terms and conditions</h3>
        <div class="divider"></div>
        <p>{{viewInvoiceData.termsAndConditions}}</p>
      </div>
      <div class="col-2">
      </div>
      <div class="col-4 ">
        <div class="p-3" *ngIf="attorneysignsrc">
          <img [src]="attorneysignsrc " alt="profile picture">
        </div>
        <div>
        <div *ngIf="viewInvoiceData.signatoryName">
          <label>Invoice Preparer</label>
        </div>
        <strong >{{viewInvoiceData.signatoryName}}(Immigration Attorney)</strong>
      </div>
      </div>
    </div>

    <form [formGroup]="clientPaymentForm">
        <div class="row  mt-3">
            <div class="col-3  nopadding">
                <label class="label-cls required"> Payment done on?</label>
                <div style="z-index:99999 ;">
                <p-calendar [(ngModel)]="paymentDate" formControlName="paymentDate" [showIcon]="true" inputId="icon"></p-calendar>
                </div>
            </div>
            <div class="col-4 nopadding">
                <p class="label-cls required mb-2">Mode of Payment</p>
                <p-dropdown class="w-100" placeholder='select payment mode' [options]="paymentmodeType"
                    optionValue="code" optionLabel="name" [(ngModel)]="paymentMode" formControlName="paymentMode" (onChange)="paymentmodeTypechanged($event)">
                </p-dropdown>
            </div>
            <div class="col-3 ml-2 mt-2" *ngIf="!cashMode">
                <p class="label-cls required ">Reference Number</p>
                <input type="text" [(ngModel)]="referenceNumber" formControlName="referenceNumber">
            </div>
            <div class="col-2">

            </div>

        </div>
        <div class="row mt-3">
          <div class="col-lg-12 nopadding">

             
              <p>Would you like to upload proof of payment</p>
              <p-fileUpload #invoiceUploader name="demo[]" mode="basic" chooseLabel="Upload" [auto]="true"
                  customUpload="true" (uploadHandler)="UploadproofofPayment($event, invoiceUploader)"
                  [accept]="acceptedTypes" invalidFileTypeMessageSummary=""
                  invalidFileTypeMessageDetail="Unaccepted format. PDF, JPG, JPEG, and PNG file types are allowed"
                  showUploadButton="false" showCancelButton="false" maxFileSize="10485760">
              </p-fileUpload>
          </div>
      </div>
        <div class="row mt-3">
            <div class="col-12 mt-4 nopadding">
                <button class="btn btn-primary" (click)="sendUpdate()" [disabled]="!this.clientPaymentForm.valid"> Send Update</button>
                <button type="button" class="btn outline-primary ml-2" (click)="cancelpaymentStatus()">Cancel</button>
            </div>
           

        </div>
      </form>
        <div class="divider mt-2 mb-2">

        </div>
        <div class="row d-flex justify-content-center align-items-center">
        
          <span> Powered by</span>     <img src="../../../../assets/images/logo-4_youtube.jpg">
          
      
          <!-- <div class="col-5"></div>
          <div class="col-1 ml-3">
            Powered by
          </div>
          <div class="col-1">
            <img src="../../../../assets/images/logo-4_youtube.jpg">
          </div>
          <div class="col-5"></div> -->
        </div>
        </div>

    
      

    
